

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {MascaraTransportadorSacPublico} from '@/model/resource/MascaraTransportadorSacPublico'
import {MascaraTransportadorSacPublicoCollection} from '@/model/collection/MascaraTransportadorSacPublicoCollection'
import {ListMascaraTransportadorSacPublicoSchema} from '@/schema/resource/MascaraTransportadorSacPublico/ListMascaraTransportadorSacPublicoSchema'
import {CsvMascaraTransportadorSacPublicoSchema} from '@/schema/resource/MascaraTransportadorSacPublico/CsvMascaraTransportadorSacPublicoSchema'

@Component
export default class ListMascaraTransportadorSacPublicoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListMascaraTransportadorSacPublicoSchema()
  collection = new MascaraTransportadorSacPublicoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: MascaraTransportadorSacPublico) {
    Helper.pushByName('editMascaraTransportadorSacPublico', item.$id)
  }

  async removeItem(item: MascaraTransportadorSacPublico) {
    await new DialogRemove(item).confirm(() =>
      item.removeMascaraTransportadorSacPublico()
    )
    await this.collection.listMascaraTransportadorSacPublico()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new MascaraTransportadorSacPublicoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvMascaraTransportadorSacPublico()
    new CsvMascaraTransportadorSacPublicoSchema().downloadCsv(csv.all())
  }
}
